import { AuthService } from '@services/auth/auth.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActiveDesactiveUser } from '@classes/user/ActiveDesactiveUser';
import { AddUser, Client, UpdateUser } from '@classes/user/userAdd';
import { UserList } from '@classes/user/userlist';

import { environment } from '@environments/environment';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  clientChangedSubject = new Subject<boolean>();
  clientSelected: string = '';
  userActive: AddUser;
  userChangedSubject = new Subject<boolean>();

  private baseUrl: string = environment.apiUrl + '/users';

  constructor(private http: HttpClient, private authSrv: AuthService) {}

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getListusers(): Observable<UserList[]> {
    return this.http.get<UserList[]>(`${environment.apiUrl}/users`);
  }

  /* -------------------------------------------------------------------------- */
  /*                                    POST                                    */
  /* -------------------------------------------------------------------------- */

  addUser(newUser: AddUser) {
    return this.http.post(`${environment.apiUrl}/users`, newUser, {
      headers: {
        authorization: `Bearer ${localStorage.getItem(environment.tokenKey)}`,
      },
    });
  }

  sendPasswordUser(username: string) {
    const formData = new FormData();
    formData.append('username', username);
    return this.http.post(
      `${environment.apiUrl}/users/password-welcome-request`,
      formData,
      {
        headers: {
          authorization: `Bearer ${localStorage.getItem(environment.tokenKey)}`,
        },
      }
    );
  }

  /* -------------------------------------------------------------------------- */
  /*                                     PUT                                    */
  /* -------------------------------------------------------------------------- */

  ActiveUser(id: string, ActiveUser: boolean) {
    return this.http.put(
      `${environment.apiUrl}/users/${id}/activate`,
      ActiveUser,
      {
        headers: {
          authorization: `Bearer ${localStorage.getItem(environment.tokenKey)}`,
        },
      }
    );
  }

  DesactiveUser(id: string, DesActiveUser: boolean) {
    return this.http.put(
      `${environment.apiUrl}/users/${id}/desactivate`,
      DesActiveUser,
      {
        headers: {
          authorization: `Bearer ${localStorage.getItem(environment.tokenKey)}`,
        },
      }
    );
  }

  UpdateUser(updateUser: UpdateUser) {
    return this.http.put(`${environment.apiUrl}/users`, updateUser, {
      headers: {
        authorization: `Bearer ${localStorage.getItem(environment.tokenKey)}`,
      },
    });
  }

  // attribuer au user un client
  chooseClient(client: Client): Observable<AddUser> {
    return this.http.put<AddUser>(`${this.baseUrl}/client`, client).pipe(
      tap((editedUser) => {
        this.authSrv.changeClientUser(editedUser.client.id);
        this.clientSelected = editedUser.client.id;
        this.clientChangedSubject.next(true);
      })
    );
  }

  // je c plu ^^
  getCurrentUser() {
    return this.http
      .get<AddUser>(`${this.baseUrl}/current`, {
        headers: {
          authorization: `Bearer ${localStorage.getItem(environment.tokenKey)}`,
        },
      })
      .pipe(
        tap((user) => {
          this.userActive = user;
          this.clientSelected = user.client.id;
          this.userChangedSubject.next(true);
        })
      );
  }
}
